(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bulk-faq"] && !Shopify.designMode) return;
  try {
    
  // Modern browsers close sibling <details> automatically via the shared
  // name attribute. Older ones ignore it, so close them by hand there.
  if (!('name' in document.createElement('details'))) {
    // 'toggle' does not bubble, so listen during the capture phase.
    document.addEventListener(
      'toggle',
      (event) => {
        const item = event.target;
        if (!(item instanceof HTMLDetailsElement) || !item.open) return;

        const group = item.dataset.faqGroup;
        if (!group) return;

        document
          .querySelectorAll(`details[data-faq-group="${group}"][open]`)
          .forEach((other) => {
            if (other !== item) other.open = false;
          });
      },
      true
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
